import { useState } from "react";
import { faqsdata } from "../../data/faqs";
import faqsImg from "../../assets/Vector.svg";
import minus from "../../assets/minus.png";

interface faqProps {
  faqss: {
    heading: string;
    content: string;
  };
  i: number;
}

const FaqsContent = () => {
  const Faqcomp = ({ faqss, i }: faqProps) => {
    const [isOpen, setisOpen] = useState(false);

    return (
      <div key={i}>
        <div
          className="faqs-content"
          onClick={() => setisOpen(!isOpen)}
        >
          <p
            style={{
              fontWeight: isOpen ? 600 : 400,
              color: isOpen
                ? "var(--vidomCustomBlue)"
                : "var(--vidomSecondaryBlack)",
            }}
          >
            {faqss.heading}
          </p>
          <img
            src={isOpen ? minus : faqsImg}
            alt="plus"
          />
        </div>
        {isOpen && <p className="faqs-description">{faqss.content}</p>}
      </div>
    );
  };

  return (
    <>
      {faqsdata.map((faqss, i) => (
        <div key={i}>
          <Faqcomp
            faqss={faqss}
            i={i}
          />
        </div>
      ))}
    </>
  );
};

export default FaqsContent;
